import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import newLogo from "../../assets/newLogo.png";
import "./style.css";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const navItems = [
    { name: "Portfolio", href: "/portfolio" },
    { name: "About", href: "/about" },
    { name: "Contact", href: "/contact" },
    { name: "Blog", href: "/blog" },
  ];

  // Handle scroll effect for glassmorphism
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`nav ${isScrolled ? "nav-scrolled" : "nav-top"}`}>
      <div className="nav-container">
        <div className="nav-inner">
          {/* Logo */}
          <div className="nav-logo">
            <a href="/">
              <img src={newLogo} alt="Big Cat Graphics" />
              <span>BIG CAT GRAPHICS</span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="nav-items-desktop">
            {navItems.map((item) => (
              <a key={item.name} href={item.href} className="nav-link">
                {item.name}
              </a>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="nav-mobile-btn"
            aria-label="Toggle Menu"
          >
            {isMenuOpen ? <X size={24} color="white" /> : <Menu size={24} color="white" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="nav-items-mobile">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="nav-link-mobile"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </a>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;